declare namespace MWY {

    interface DataChangeInfo {
        type: string;
        entityId: any;
        entity: any;
    }

}